import type { Coverage } from "../model/inp/coverages.ts";
import type { LandUse } from "../model/inp/landuses.ts";
import { useT } from "../i18n/hooks.ts";
import { CatalogPickerTable } from "./CatalogPickerTable.tsx";

/** [COVERAGES] editor for one subcatchment; `coverages` is pre-filtered to it by the caller, and `onChange` replaces its rows wholesale. */
export function CoveragesEditor({
  subcatchmentName,
  landUses,
  coverages,
  onChange,
}: {
  subcatchmentName: string;
  landUses: LandUse[];
  coverages: Coverage[];
  onChange: (rows: Coverage[]) => void;
}) {
  const t = useT();
  const total = coverages.reduce((sum, c) => sum + c.percent, 0);

  return (
    <CatalogPickerTable
      rows={coverages}
      catalog={landUses}
      onChange={onChange}
      getCategory={(c) => c.landUse}
      getValue={(c) => c.percent}
      withCategory={(c, landUse) => ({ ...c, landUse })}
      withValue={(c, percent) => ({ ...c, percent })}
      newRow={(landUse) => ({ subcatchment: subcatchmentName, landUse, percent: 0 })}
      title={t("propertyPanel.coverages")}
      categoryHeader={t("propertyPanel.landUse")}
      valueHeader={t("propertyPanel.percent")}
      emptyCatalogHint={t("propertyPanel.noLandUsesYet")}
      emptyRowsHint={t("propertyPanel.noCoverages")}
      addLabel={t("propertyPanel.addCoverage")}
      deleteLabel={t("propertyPanel.deleteCoverage")}
      footer={() =>
        total !== 100 && <p className="error">{t("propertyPanel.coveragesNotFull", { total })}</p>
      }
    />
  );
}
